import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SayfalamaSonuc } from '@core/models/genel/SayfalamaSonuc';
import { environment } from '@environments/environment';

@Injectable()
export class QuickSearchService {
	
	list$: BehaviorSubject<any[]> = new BehaviorSubject([]);

	constructor(private http: HttpClient) { }

	search(query: any): Observable<any> {
		return this.http.get<SayfalamaSonuc>(environment.API_FATURALAR_URL, { params: query });
	}
}
